// This file is not yet translated.
/* eslint-disable i18next/no-literal-string */
import type { SxProps } from "@outschool/backpack";
import { lazyWithRetry, useIsMobile } from "@outschool/ui-utils";
import React, { Suspense } from "react";

import { useAllNavbarCategories } from "./navbarCategories";

const DesktopCategoryNavbar = lazyWithRetry(
  () =>
    import(
      /* webpackChunkName: "desktopCategoryNavbar" */ "./DesktopCategoryNavbar"
    ),
);
const DesktopCategoryNavbarButton = lazyWithRetry(
  () =>
    import(
      /* webpackChunkName: "desktopCategoryNavbarButton" */ "./DesktopCategoryNavbarButton"
    ),
);
const MobileCategoryNavbar = lazyWithRetry(
  () =>
    import(
      /* webpackChunkName: "mobileCategoryNavbar" */ "./MobileCategoryNavbar"
    ),
);

export default function CategoryNavbar({
  sx = {},
  useButton,
  useSearchLinks = false,
}: {
  sx?: SxProps;
  useButton?: boolean;
  // When true, links to the search page with category filters applied instead of the category page
  useSearchLinks?: boolean;
}) {
  const isMobile = useIsMobile();

  const navbarCategories = useAllNavbarCategories(useSearchLinks);

  return (
    <nav style={{ zIndex: 201, position: "relative" }}>
      <Suspense fallback={null}>
        {isMobile ? (
          <MobileCategoryNavbar
            categories={navbarCategories}
            sx={sx}
            useSearchLinks={useSearchLinks}
          />
        ) : useButton ? (
          <DesktopCategoryNavbarButton
            categories={navbarCategories}
            sx={sx}
            useSearchLinks={useSearchLinks}
          />
        ) : (
          <DesktopCategoryNavbar
            categories={navbarCategories}
            sx={sx}
            useSearchLinks={useSearchLinks}
          />
        )}
      </Suspense>
    </nav>
  );
}

export { default as DesktopCategoryNavbar } from "./DesktopCategoryNavbar";
export { default as MobileCategoryNavbar } from "./MobileCategoryNavbar";
export * from "./navbarCategories";
